import { useModal, useModalExtra } from '../../../../_components/Modal'
import { useModifyClassList } from '../../../../common/utils/CSSUtils'

/**
 * 未保存変更確認モーダルを表示するフック。 open(action) 呼び出しでモーダルを表示し、SET_IS_UNSAVED_MODAL_OPEN をフック内で dispatch する。
 *
 * @param {object} opts
 * @param {function(string, any): void} opts.dispatch
 * @param {string} opts.currentTab - 'mapping' | 'validation'
 * @param {function(action: { kind: 'tab-switch', nextTab: string } | { kind: 'navigate-back' }): void} opts.onDiscard
 * @param {function(action: { kind: 'tab-switch', nextTab: string } | { kind: 'navigate-back' }): Promise<void>} opts.onSave
 * @param {function(Error): void} opts.onSaveError - 保存失敗時のエラー表示（モーダルは閉じる）
 * @param {boolean} [opts.canSave]
 * @returns {{ open: function({ kind: string, nextTab?: string }): void }}
 */
export function useUnsavedChangesModal({ dispatch, currentTab, onDiscard, onSave, onSaveError, canSave = true }) {
  const showModal = useModal()
  const { _closeUpModal } = useModalExtra()
  const { promisify } = useModifyClassList('.modal-window', ['w-[640px]'])

  const open = (action) => {
    dispatch('SET_IS_UNSAVED_MODAL_OPEN', true)
    const tabLabel = currentTab === 'mapping' ? 'マッピング設定' : 'データ検証'
    // 遷移先ラベルと動詞（移動/戻る）は action.kind で対にして決める
    const { targetLabel, actionLabel } =
      action?.kind === 'tab-switch'
        ? {
            targetLabel: action.nextTab === 'validation' ? '「データ検証タブ」' : '「マッピング設定タブ」',
            actionLabel: '移動'
          }
        : { targetLabel: 'レポートデータ更新画面に戻る', actionLabel: '戻る' }
    promisify((resolve) => {
      const handleClose = () => {
        dispatch('SET_IS_UNSAVED_MODAL_OPEN', false)
        resolve()
      }
      showModal({
        title: '未保存の変更があります',
        description: (
          <p>
            {tabLabel}タブに未保存の変更があります。
            <br />
            {targetLabel}前に、変更を保存しますか？
          </p>
        ),
        onClose: handleClose,
        isCancel: false,
        isWide: false,
        footerButtonAreaClass: 'gap-x-8',
        button: [
          {
            name: `破棄して${actionLabel}`,
            className: 'footer-btn button_back',
            click: () => {
              onDiscard(action)
              _closeUpModal()
            }
          },
          {
            name: `保存して${actionLabel}`,
            className: 'footer-btn button_base',
            disabled: !canSave,
            click: async () => {
              try {
                await onSave(action)
              } catch (error) {
                onSaveError(error)
              }
              _closeUpModal()
            },
            close: false
          }
        ]
      })
    })
  }

  return { open }
}
